const routes = [
  {
    name: 'wechatBindBind',
    path: '/progress/pages/bind/bind',
    component: () => import('@pages/account-bind/bind'),
  },
  {
    name: 'wechatBindValid',
    path: '/progress/pages/bind/vcode',
    component: () => import('@pages/account-bind/valid'),
  },
  {
    name: 'wechatBindResult',
    path: '/progress/pages/bind/bindResult',
    component: () => import('@pages/account-bind/bind-result'),
  },
  {
    name: 'wechatBindUnBind',
    path: '/progress/pages/bind/unbind',
    component: () => import('@pages/account-bind/un-bind'),
  },
  {
    name: 'wechatBindUnBindResult',
    path: '/progress/pages/bind/unbindResult',
    component: () => import('@pages/account-bind/un-bind-result'),
  },
];

export default routes;
